import React from "react";
import { Img } from "../Img";
export const TradingViewSmallButton = ({ urlLink, imageUrl, imageAlt }) => (React.createElement("a", { className: "trading-view-small-button", href: urlLink, target: "_blank", rel: "noreferrer" },
    React.createElement(Img, { src: imageUrl, alt: imageAlt })));
